import {Article} from "@proto/chatbot/v1alpha/chatbot"
import RelatedMessage from "./RelatedMessage"

interface IProps {
    articles?: Article[]
}

const SponsoredArticleList = ({articles}: IProps) => {
    if (!articles) {
        return
    }

    return <RelatedMessage sponsoredArticles={articles} />
}

export default SponsoredArticleList
